import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SharedMethodsService } from 'src/app/services/shared-methods.service';
import { UserStorageService } from 'src/app/services/storage/user-storage.service';
import { environment } from 'src/environments/environment';
import { StartReport } from '../../data-models/report-models/start-report.model';
import { Trip } from '../../data-models/trip-models/trip.model';
import { UserData } from '../../data-models/user-models/user-data.model';
import { AddVesselDialogComponent } from '../../dialogs/add-vessel-dialog/add-vessel-dialog.component';
import { AuthenticationService } from '../../services/authentication.service';


@Component({
    selector: 'app-no-trip-home',
    templateUrl: './no-trip-home.component.html',
    styleUrls: ['./no-trip-home.component.css'],
    standalone: false
})
export class NoTripHomeComponent implements OnInit {

  isDataLoaded: boolean = false; // flag that tells us if the HTML is ready to be rendered
  isProduction: boolean = environment.production;

  //data preambles
  userDetails: UserData = new UserData();
  adminUser?: UserData;
  currTrip: Trip = new Trip();

  constructor( // same constructor as original homepage
    private dialog: MatDialog,
    private ref: ChangeDetectorRef,
    private router: Router,
    public sharedMethodsService: SharedMethodsService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.userDetails = UserStorageService.currUser;
    this.adminUser = UserStorageService.adminUser;
    if (!this.adminUser) {
      UserStorageService.getCurrTrip().then(() => {
        if (this.authenticationService.dataError(UserStorageService.error)) {
          return;
        }
        this.currTrip = UserStorageService.currTrip;
        this.initialize();
      });  
    } else {
      this.isDataLoaded = true;
    }
  }
  
  /*  ---------- Initialization Methods  ---------- */


  initialize(): void {

    // save recently completed trip information
    this.saveOldTrip();

    this.isDataLoaded = true; // set flag to render HTML
    this.ref.detectChanges(); // re-render HTML

  }


  // returns true if the trip has not yet been saved and false if it has previously been saved
  isTripUnsaved(): boolean {

    return this.currTrip.isValid() && this.currTrip.startFishingReport.isComplete;

  };

  // saves trip data from the recently completed trip
  saveOldTrip(): void { 

    if (this.isTripUnsaved()) { // check if there is a trip to save
      console.log("Saving trip...");
      UserStorageService.saveTrip(this.currTrip, false).then(() => {
        UserStorageService.submitTrip();
        console.log("Trip saved!");
      });
    }

  }

  // Checks the user's logbooks to determine if they only have inactive logbooks
  hasOnlyInactiveLogbooks(): boolean {
    return this.userDetails.logbooks.every(lb => lb.isActive === false);
  }

  // Checks the user's logbooks to determine if they have a valid logbook
  hasRegisteredLogbook(): boolean {
    return this.userDetails.logbooks.some(lb => lb.isRegistered && (lb.isActive ?? true));
  }


  // Checks the user's logbooks to determine if there is an unregistered logbook in their list
  // Used to show a message to the user that they have a logbook but no matching VRN in their vessels
  hasUnRegisteredLogbook(): boolean {
    return this.userDetails.logbooks.some(logbook => !logbook.isRegistered);
  }




  /*  ---------- Report Navigation Methods  ---------- */


  // go to start a fishing report
  toStartReport(): void {

    let newStartReport = new StartReport();
    this.router.navigate(['start-report', newStartReport.internalId], { queryParams: { status: 'new' } });
    
  }


  /*  ---------- Dialog Methods  ---------- */


  // lets the user enter a vessel
  addVesselDialog(): void {

    const dialogRef: MatDialogRef<AddVesselDialogComponent, any> = this.dialog.open(AddVesselDialogComponent, {
      width: '500px',
      height: '550px',
      data: { userDetails: this.userDetails }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result !== 'Back') {
        this.sharedMethodsService.toastVesselAdded();
      }
    });

  }

}
